'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ramda = require('ramda');

var _ramdaAdjunct = require('ramda-adjunct');

var _breakpointMapping = require('../../lib/utils/breakpointMapping');

var _rootPxToEmTransformer = require('../transformers/rootPxToEmTransformer');

var _rootPxToEmTransformer2 = _interopRequireDefault(_rootPxToEmTransformer);

var _breakpointMap = require('../utils/breakpointMap');

var _breakpointMapping2 = require('../utils/breakpointMapping');

var _breakpoints = require('../utils/breakpoints');

var _functions = require('../utils/functions');

var _list = require('../utils/list');

var _objects = require('../utils/objects');

var _parse = require('../utils/parse');

var _predicate = require('../utils/predicate');

var _range = require('../utils/range');

var _templates = require('../utils/templates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var breakpointValuesToEms = (0, _ramda.map)((0, _ramda.apply)((0, _ramda.useWith)(_ramdaAdjunct.list, [_ramda.identity, (0, _ramda.unless)(_predicate.isEmString, _rootPxToEmTransformer2.default)])));

var queryHeader = function queryHeader(idx, mappedValues) {
  return function (name) {
    var queryValue = (0, _breakpointMapping2.propQuery)(mappedValues[idx]);
    if (idx < mappedValues.length - 1) {
      var nextQueryValue = (0, _breakpointMapping2.propQuery)(mappedValues[idx + 1]);
      return (0, _predicate.isDefaultBreakpoint)(name) ? (0, _templates.createQueryMaxHeaderFromTemplate)(nextQueryValue) : (0, _templates.createQueryMinMaxHeaderFromTemplate)(nextQueryValue, queryValue);
    }
    return (0, _predicate.isDefaultBreakpoint)(name) ? null : (0, _templates.createQueryMinHeaderFromTemplate)(queryValue);
  };
};

var applyOffsetToBreakpointValue = function applyOffsetToBreakpointValue(rangeItem) {
  return (0, _ramda.cond)([[(0, _ramda.pipe)(_range.propOffset, _ramda.isNil), _breakpointMapping.propValue], [(0, _ramda.both)((0, _ramda.pipe)(_breakpointMapping2.propName, _predicate.isDefaultBreakpoint), (0, _ramda.pipe)(_range.propOffset, _predicate.hasNegativeOffset)), function () {
    return 0;
  }], [_ramda.T, (0, _ramda.pipe)(_range.propOffset, (0, _ramda.unless)(_predicate.isEmString, _rootPxToEmTransformer2.default), (0, _parse.addEmValues)(rangeItem.value))]])(rangeItem);
};

var renderGtQuery = function renderGtQuery(breakpointMap, rangeItem, rangeItemValue) {
  return (0, _predicate.isDefaultBreakpoint)(rangeItem.name) ? null : (0, _templates.createQueryMinHeaderFromTemplate)(rangeItemValue);
};

var renderLtQuery = function renderLtQuery(breakpointMap, rangeItem, rangeItemValue) {
  return (0, _templates.createQueryMaxHeaderFromTemplate)(rangeItemValue);
};

var renderAtQuery = function renderAtQuery(breakpointMap, rangeItem, rangeItemValue) {
  // We need to limit ourselves using a max of the next query if it exists.
  // Use our own index to check if there is a breakpoint after us
  var idx = (0, _breakpointMap.findBreakpointIndex)(breakpointMap, rangeItem.name);

  if ((0, _breakpointMap.isNotLastBreakpoint)(breakpointMap, idx)) {
    // It does exist so get its value
    var nextBreakpointValue = (0, _ramda.pipe)((0, _breakpointMap.findNextBreakpointByIndex)(breakpointMap), (0, _ramda.nth)(1))(idx);
    return (0, _predicate.isDefaultBreakpoint)(rangeItem.name) ? (0, _templates.createQueryMaxHeaderFromTemplate)(nextBreakpointValue) : (0, _templates.createQueryMinMaxHeaderFromTemplate)(nextBreakpointValue, rangeItemValue);
  }
  // Otherwise we are the last breakpoint so we don't need a max
  return (0, _templates.createQueryMinHeaderFromTemplate)(rangeItemValue);
};

var renderRangeQuery = function renderRangeQuery(breakpointMap, firstRangeItem, firstItemValue, range) {
  var secondItemValue = (0, _ramda.pipe)((0, _ramda.nth)(1), applyOffsetToBreakpointValue)(range);
  return (0, _predicate.isDefaultBreakpoint)(firstRangeItem.name) && firstItemValue === 0 ? (0, _templates.createQueryMaxHeaderFromTemplate)(secondItemValue) : (0, _templates.createQueryMinMaxHeaderFromTemplate)(secondItemValue, firstItemValue);
};

var renderSingleQuery = (0, _ramda.cond)([[(0, _ramda.either)(_range.hasNoModifier, _predicate.modifierIsGtModifier), function () {
  return renderGtQuery;
}], [_predicate.modifierIsLtModifier, function () {
  return renderLtQuery;
}], [_ramda.T, function () {
  return renderAtQuery;
}]]);

var createQueryHeaderFromRange = function createQueryHeaderFromRange(breakpointMap) {
  return function (range) {
    var firstRangeItem = (0, _ramda.head)(range);
    var firstItemValue = applyOffsetToBreakpointValue(firstRangeItem);
    var renderQuery = (0, _list.lengthEq1)(range) ? renderSingleQuery(firstRangeItem) : renderRangeQuery;
    return renderQuery(breakpointMap, firstRangeItem, firstItemValue, range);
  };
};

var attachBreakpointValues = function attachBreakpointValues(breakpointMap) {
  return function (name, range) {
    return (0, _ramda.map)(function (rangeItem) {
      return (0, _ramda.pipe)(_breakpointMapping2.propName, (0, _breakpointMap.findBreakpointByName)(breakpointMap), (0, _breakpointMapping2.assocValue)(_ramda.__, rangeItem))(rangeItem);
    }, range);
  };
};

var queryHeaderForRange = function queryHeaderForRange(breakpointMap) {
  return (0, _ramda.pipe)(attachBreakpointValues(breakpointMap), createQueryHeaderFromRange(breakpointMap));
};

// -----------------------------------------------------------------------------
// API
// -----------------------------------------------------------------------------

var createApi = function createApi(breakpointMap) {
  // Resolve breakpoints for values declared using an object syntax
  var byName = function byName(values) {
    // Parse the breakpoint descriptors
    var parsedValues = (0, _objects.reduceObjIndexed)(function (mappings, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          name = _ref2[0],
          value = _ref2[1];

      return (0, _ramda.pipe)(_breakpoints.parseBreakpoint, (0, _breakpointMapping2.assocValue)(value), (0, _ramdaAdjunct.appendFlipped)(mappings))(name);
    }, [], values);
    // Create query headers
    return (0, _ramda.reduce)(function (mappings, _ref3) {
      var name = _ref3.name,
          range = _ref3.range,
          value = _ref3.value;
      return (0, _ramda.pipe)(queryHeaderForRange(breakpointMap), (0, _breakpointMapping2.createBreakpointMapping)(name, value), (0, _ramdaAdjunct.appendFlipped)(mappings))(name, range);
    }, [], parsedValues);
  };

  // Resolve breakpoints for values declared using an array syntax
  var byIndex = function byIndex(values) {
    var mappedValues = (0, _breakpointMap.buildMappingsByIndex)(breakpointMap, values);

    // Render the appropriate template
    return (0, _ramdaAdjunct.mapIndexed)(function (value, idx) {
      return (0, _ramda.pipe)(_breakpointMapping2.propName, queryHeader(idx, mappedValues), (0, _breakpointMapping2.assocQuery)(_ramda.__, value))(value);
    }, mappedValues);
  };

  var count = function count() {
    return (0, _list.numKeys)(breakpointMap);
  };

  return {
    byIndex: byIndex,
    byName: byName,
    count: count
  };
};

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

var defaultBreakpointMapProvider = (0, _ramda.pipe)(_functions.defaultToObj, breakpointValuesToEms, createApi);

exports.default = defaultBreakpointMapProvider;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/breakpoints/defaultBreakpointProvider.js
// module id = 639
// module chunks = 168707334958949